let headerSearch = document.getElementById('headerSearch');
let headerSearchFormWrapperDesktop = document.getElementById('headerSearchFormWrapperDesktop');
let headerSearchCloseWrapperDesktop = document.getElementById('headerSearchCloseWrapperDesktop');
let menuCloseButton = document.getElementById('menuCloseButton');
let headerSearchLayer = document.getElementById('headerSearchLayer');
let headerSearchInputMobile = document.querySelector('.header_search_layer .headerSearchInputMobile');
let headerSearchInputDesktop = document.querySelector('.header_main .headerSearchInputDesktop');

// Header search toggle
function headerSearchToggle() {
    // noScroll class
    if (headerMenu.classList.contains('is-active')) {
        document.body.classList.add('noScroll');
    } else {
        document.body.classList.toggle('noScroll');
    }

    // Close header menu
    headerMenu.classList.remove('is-active');
    headerNavigationLayer.classList.remove('is-active');

    // Toggle header search
    headerSearch.classList.toggle('is-active');
    headerSearchLayer.classList.toggle('is-active');

    const isMobile = window.matchMedia('(max-width: 1199px)');

    if (isMobile.matches) {
        headerSearchInputMobile.focus();
    } else {
        headerSearchFormWrapperDesktop.classList.toggle('is-active');
        headerSearchCloseWrapperDesktop.classList.toggle('is-active');
        document.body.classList.remove('noScroll');
        headerSearchInputDesktop.focus();
    }
}

// Header search close
function headerSearchClose() {
    headerSearch.classList.remove('is-active');
    headerSearchFormWrapperDesktop.classList.remove('is-active');
    headerSearchCloseWrapperDesktop.classList.remove('is-active');
    headerSearchLayer.classList.remove('is-active');
    document.body.classList.remove('noScroll');
}

headerSearch.addEventListener('click', headerSearchToggle);
menuCloseButton.addEventListener('click', headerSearchClose);
